<template>
    <div class="card">
        <div class="card-content">
            <slot name="content"></slot>
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'cardWrapper',
  data () {
   return {
     
   }
  },
  
}
</script>

